var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('StoneHeader'),_c('div',{staticClass:"regulation"},[_c('h1',[_vm._v("イベント非公開")]),_c('article',[_c('dl',[_c('dt',[_vm._v("このページは現在非公開です。")]),_c('dd',[_vm._v("イベントの準備が出来次第、公開となります。")])])])]),_c('StoneFooter')],1)}
var staticRenderFns = []

export { render, staticRenderFns }